import { forwardRef, useImperativeHandle } from 'react'
import type { ReactNode } from 'react'
import { EditorContent } from '@tiptap/react'
import { useTranslation } from 'next-i18next/pages'
import { useFormContext } from 'react-hook-form'
import type { MentionInterface } from 'modules/comments/components/comment/comment.types'
import HoveringToolbar from 'modules/community/post/horizontal-toolbar'
import { useEditor } from '../../editor/hooks/use-editor'

export interface EditorRef {
  clear: () => void
  insertEmoji: (emoji: string) => void
}

interface AddPostContentEditorProps {
  content?: string
  mentions?: MentionInterface[]
}

const AddPostContentEditor = forwardRef<EditorRef, AddPostContentEditorProps>(
  function AddPostContentEditor(props, ref): ReactNode {
    const { t } = useTranslation()
    const { setValue } = useFormContext()

    const { editor, insertEmoji, clearContent } = useEditor({
      contentHtml: props.content,
      mentions: props.mentions,
      onHtmlChange: html => setValue('content', html),
    })

    useImperativeHandle(ref, () => ({
      clear: clearContent,
      insertEmoji,
    }))

    return (
      <div className="mb-6">
        <p className="mb-1 text-base font-medium text-text-primary">{t('home.add_post.content')}</p>
        {editor ? (
          <div>
            <HoveringToolbar editor={editor} />
            <EditorContent editor={editor} />
          </div>
        ) : null}
      </div>
    )
  },
)

export default AddPostContentEditor
